import { ProposalFormDataLineItem } from 'types/proposal';
import generateUUIDv4 from 'utils/generateUUIDv4';

export const getGeneratedInitialLineItem = (): ProposalFormDataLineItem => ({
    id: generateUUIDv4(),
    name: '',
    description: '',
    total: '0',
});

export const getTotalAmount = (values: ProposalFormDataLineItem[]) => values.reduce((acc, cur) => acc + +cur.total, 0);
